module.exports = __webpack_public_path__ + "Simple-Line-Icons.f33df365d6d0255b586f.eot";


//////////////////
// WEBPACK FOOTER
// D:/Works/Safetyminder/Safetyminder/Admin/src/assets/fonts/Simple-Line-Icons.eot?v=2.4.0
// module id = ../../../../../src/assets/fonts/Simple-Line-Icons.eot?v=2.4.0
// module chunks = styles